import {customAxios, IDUSUARIO, TOKEN, USERNAME, FDV_URL, STOCK_URL} from '../constants';
import {FETCH_INMATRICULACION, FETCH_INMATRICULACION_DOCUMENTOS} from './types';
import { evalAction, serverError } from '../utils/actionError';

export function fetchInmatriculacion(id,numPedidoVeh) {
  const config = {
    params: {
      codigo:id,
      numPedidoVeh:numPedidoVeh
    },
    headers: {
      codUsuario: USERNAME,
      idUsuario: IDUSUARIO,
      token: TOKEN,
    }
  };

  const request = customAxios.get(`${FDV_URL}/ficha-venta/fichas-venta/${id}/inmatriculaciones`, config)
  .then(({ data }) => evalAction(data, 'listar'))
  .catch(error => serverError(error, 'listar'))

  return {
    type: FETCH_INMATRICULACION,
    payload: request,
  };
}

export function fetchDetalleFacturas(value) {
  const config = {
    params: value,
    headers: {
      codUsuario: USERNAME,
      idUsuario: IDUSUARIO,
      token: TOKEN,
    }
  };

  const request = customAxios.get(`${STOCK_URL}/envio-correo-archivo-xml/listar-documento`, config);

  return {
    type: FETCH_INMATRICULACION_DOCUMENTOS,
    payload: request,
  };
}



// WEBPACK FOOTER //
// ./src/actions/Inmatriculacion.js